import { render, staticRenderFns } from "./WheelsetMeasures.vue?vue&type=template&id=c5e9b632&scoped=true"
import script from "./WheelsetMeasures.vue?vue&type=script&lang=js"
export * from "./WheelsetMeasures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e9b632",
  null
  
)

export default component.exports